export default {
  default_program_name: 'Clube de Recompensas',
  message:
    'Junte-se ao <highlight>{{name}}</highlight> — ganhe {{reward}} por cada {{spend}} gasto e desbloqueie itens gratuitos do menu!',
  buttons: {
    join_now: 'Aderir Agora',
  },
};
